
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesReturnItemsBOMGrid extends Serenity.EntityGrid<SalesReturnItemsBOMRow, any> {
        protected getColumnsKey() { return 'Sales.SalesReturnItemsBOM'; }
        protected getDialogType() { return SalesReturnItemsBOMDialog; }
        protected getIdProperty() { return SalesReturnItemsBOMRow.idProperty; }
        protected getInsertPermission() { return SalesReturnItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesReturnItemsBOMRow.localTextPrefix; }
        protected getService() { return SalesReturnItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}